// Originalfotos der alten Früchte-Seiten (www.balivwtour.com), große Auflösung.
export const fruitPhotos: Record<string, string[]> = {
  banane: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/banana_flower03_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/banana_fruits01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/banana_fruits03_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/banana_fruits04_large.jpg",
  ],
  papaya: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/papaya06_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/papaya_blossom01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/papaya04_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/papaya05_large.jpg",
  ],
  ananas: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/pineapple02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/pineapple01_large.jpg",
  ],
  maracuja: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/maracuja01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/maracuja02_large.jpg",
  ],
  mango: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/mango_fruit04_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/mangofruit01_large.jpg",
  ],
  rambutan: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/rambutan_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/rambutan_fruit02_large.jpg",
  ],
  litschi: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/litchi01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/litchi02_large.jpg",
  ],
  duku: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/langsat_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/langsat_fruit02_large.jpg",
  ],
  mangostane: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/mangosteen_fruits01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/mangosteen01_large.jpg",
  ],
  durian: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/durianfruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/durianfruit04_large.jpg",
  ],
  salak: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/salak_fruits01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/salak_fruits02_large.jpg",
  ],
  karambole: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/carambola_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/carambola_fruit02_large.jpg",
  ],
  guave: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/guava_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/guava_fruit02_large.jpg",
  ],
  annone: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/annona_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/annona_fruit02_large.jpg",
  ],
  avocado: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/avocado01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/avocado02_large.jpg",
  ],
  jackfrucht: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/jackfruit02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/jackfruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/jackfruit_on_tree01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/jackfruit_wood01_large.jpg",
  ],
  rosenapfel: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/jambu01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/jambu02_large.jpg",
  ],
  sirsak: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sirsak_fruit02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sirsak_fruit01_large.jpg",
  ],
  sapote: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sapo_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sapo_on_tree01_large.jpg",
  ],
  tamarillo: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/tamarillo_fruits01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/tamarillo_tree01_large.jpg",
  ],
};